import { lt, showSuccessAlert } from '@mews/framework';
import { createFetchAction } from '@mews-commander/utils';
import { COMMAND_CREATE } from './constants';

export function createCommand(baseUrl: $TSFixMe, params: $TSFixMe, successMessageKey?: Mews.TextKey) {
    return (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const promise = container()
            .commandComponent.addCommand(baseUrl, params)
            .then(() => {
                if (successMessageKey) {
                    showSuccessAlert({ description: lt(successMessageKey) });
                }
            });

        return dispatch(createFetchAction(COMMAND_CREATE, { promise }));
    };
}
